<template>
  <b-col cols="12" md="12" lg="6" style="min-height: 200px">
    <h5>
      {{ $t('cascade_access.non_overridden_accesses_on_other_resources') }}
    </h5>
    <b-button class="my-2" variant="secondary"
              @click="onExcludedAccessCreate">
      {{ $t('cascade_access.exclude_access') }}
    </b-button>
    <loader v-if="excludedLoading"/>
    <v-client-table
        v-if="excludedCascadeAccessesTableData && !excludedLoading"
        :data="excludedCascadeAccessesTableData"
        :columns="excludedTableConfig.columns"
        :options="excludedTableConfig.options">
      <template slot="active" slot-scope="props">
        <column-check :row="props.row" column="active"/>
      </template>
      <template slot="actions" slot-scope="props">
        <column-action
            :show-edit-button="true"
            @edit="onExcludedAccessUpdate(props.row)"
            :deleteUrl="`partners/${partnerId}/cascade-access/exclude/${props.row.id}`"
            @deleteItems="getExcludedCascadeAccesses"/>
      </template>
    </v-client-table>
  </b-col>
</template>

<script>
import i18n from "@/utils/i18n";
import {get} from "lodash";

export default {
  name: "ExcludedCascadeAccessView",
  components: {},
  props: {
    partnerId: {
      type: Number,
      required: true
    },
    resourceKey: {
      type: String,
      required: true
    },
    cascadeAccess: {
      type: Object,
      required: true
    },
    partnerResources: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      usedResources: [],
      excludedCascadeAccessesTableData: [],
      excludedLoading: false,
      loading: false,
      excludedTableConfig: {
        columns: ['resource', 'type', "access", "active", "actions"],
        options: {
          skin: 'table-p-1',
          headings: {
            active: i18n.t('form.active'),
            actions: "",
          },
          filterable: false
        }
      }
    }
  },
  created() {
    this.getExcludedCascadeAccesses();
  },
  mounted() {
    this.$bus.$on(`reloadExcludedCascadeAccesses-${this.cascadeAccess.id}`,
        () => {
          this.getExcludedCascadeAccesses();
        });
  },
  destroyed() {
    this.$bus.$off(`reloadExcludedCascadeAccesses-${this.cascadeAccess.id}`);
  },
  methods: {
    async getExcludedCascadeAccesses() {
      this.excludedLoading = true
      this.getData(`partners/${this.partnerId}/cascade-access/${this.cascadeAccess.id}/exclude`)
          .then(({data}) => {
            if (Array.isArray(data.items)) {
              this.excludedCascadeAccessesTableData = data.items.map((item) => {
                return {
                  id: item.id,
                  resource: item.resource.title,
                  type: this.getExcludedCascadeAccessTypeTitle(item),
                  access: this.getExcludedCascadeAccessSource(item),
                  active: item.active,
                  rawData: item
                }
              })
              this.usedResources = [this.resourceKey];
            }
          })
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          })
          .finally(() => {
            this.excludedLoading = false;
          })
    },

    onExcludedAccessUpdate(excludedAccessItem) {
      this.$bus.$emit('openUpdateExcludedCascadeAccess', {
        usedResources: this.usedResources,
        excludedAccessItem: excludedAccessItem
      }, this.getExcludedCascadeAccessType())
    },

    onExcludedAccessCreate() {
      this.$bus.$emit('openCreateExcludedCascadeAccess', {
        usedResources: this.usedResources
      }, this.getExcludedCascadeAccessType())
    },

    getExcludedCascadeAccessTypeTitle(item) {
      if (item.subscription_id) return i18n.t('cascade_access.type_subscription')
      if (item.ti_event_ticket_id) return i18n.t('cascade_access.type_ticket')
      if (item.content_id) return i18n.t('cascade_access.type_content')
    },

    getExcludedCascadeAccessSource(item) {
      if (item.subscription_id) {
        return `${item.subscription.plan.title} -> ${item.subscription.title}`;
      }
      if (item.ti_event_ticket_id) {
        return `${item.ti_event_ticket.ti_event.title} -> ${item.ti_event_ticket.title}`;
      }
      if (item.content_id) return item.content.title;
    },

    getExcludedCascadeAccessType() {
      if (get(this.cascadeAccess, "subscription", null)) {
        return "type_subscription";
      }
      if (get(this.cascadeAccess, "ti_event_ticket", null)) {
        return "type_ticket";
      }
      if (get(this.cascadeAccess, "content", null)) {
        return "type_content";
      }
      return null;
    },
  }
}
</script>

